var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.announcements.length > 0)?_c('div',{staticClass:"announcement-container"},_vm._l((_vm.announcements),function(announcement){return _c('AnnouncementBar',{key:announcement.id,attrs:{"announcement":announcement}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }